import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class ValidationService {
  emailRegex = /^\s*(([^<>()\[\]\\.,;:\s@"\u0600-\u06FF]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))\s*$/;
  passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*\W).{8,32}$/;
  facebookRegex = /^https?:\/\/([a-z0-9]+\.)?facebook\.com\/[A-Za-z0-9._~\-\/?&=#:%]+$/i;
  instagramRegex = /^https?:\/\/(www\.)?instagram\.com\/[A-Za-z0-9._~\-\/?&=#:%]+$/i;
  tiktokRegex = /^https?:\/\/(www\.)?tiktok\.com\/[@A-Za-z0-9._~\-\/?&=#:%]+$/i;
  urlRegex = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/;

  constructor() { }
}
